module.exports = __webpack_public_path__ + "img/machinegun.88eaccf7.svg";